
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2YWxz", function(module, exports) {

$parcel$export(module.exports, "RequestToEditButtonComponent", () => $028f68c4035a3bb9$export$9b6b5efb5fed0902);
$parcel$export(module.exports, "RequestToEdit", () => $028f68c4035a3bb9$export$3e2d536de1c1140d);

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $dBxQj = parcelRequire("dBxQj");

var $9YwaJ = parcelRequire("9YwaJ");

var $cvXh8 = parcelRequire("cvXh8");

var $dIouf = parcelRequire("dIouf");

var $7aRa9 = parcelRequire("7aRa9");

var $9wGTI = parcelRequire("9wGTI");

var $aXWbQ = parcelRequire("aXWbQ");

var $kKgGX = parcelRequire("kKgGX");
const $028f68c4035a3bb9$var$REQUEST_SENT_FLAG_ID = 'request-to-edit-sent';
const $028f68c4035a3bb9$export$9b6b5efb5fed0902 = ({ contentId: contentId, flags: flags, requestToEditContent: requestToEditContent, hasRequestedEditPermission: hasRequestedEditPermission = false })=>{
    const [requestSent, setRequestSent] = (0, $gwFzn.useState)(false);
    const intl = (0, $dBxQj.default)();
    (0, $gwFzn.useEffect)(()=>{
        // reset the state requestSent on the content change
        setRequestSent(false);
    }, [
        contentId
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if ((0, $9wGTI.fg)('editor_request_to_edit_task')) setRequestSent(hasRequestedEditPermission);
    }, [
        hasRequestedEditPermission
    ]);
    const showRequestSentFlag = (ownerName)=>{
        flags.showSuccessFlag({
            id: $028f68c4035a3bb9$var$REQUEST_SENT_FLAG_ID,
            title: intl.formatMessage((0, $aXWbQ.messages).requestSentFlagTitle),
            description: intl.formatMessage((0, $aXWbQ.messages).requestSentFlagDescription, {
                ownerName: ownerName
            }),
            actions: [
                {
                    content: intl.formatMessage((0, $aXWbQ.messages).requestSentFlagAction),
                    onClick: ()=>flags.hideFlag($028f68c4035a3bb9$var$REQUEST_SENT_FLAG_ID)
                }
            ]
        });
    };
    const showNotSentFlag = ()=>{
        flags.showWarningFlag({
            title: intl.formatMessage((0, $aXWbQ.messages).notSentFlagTitle),
            description: intl.formatMessage((0, $aXWbQ.messages).notSentFlagDescription),
            appearance: 'warning',
            isAutoDismiss: true
        });
    };
    // Once we have the success response set the state requestSent to true
    const handleRequestComplete = (result)=>{
        if (result?.experimentalRequestAccess?.complete) {
            setRequestSent(true);
            const ownerName = result?.experimentalRequestAccess?.fullName || '';
            showRequestSentFlag(ownerName);
        } else showNotSentFlag();
    };
    const [requestAccess, { loading: loading }] = (0, $j1Ss3.useMutation)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Read https://go/connie-relay-migration-fyi
    (0, $kKgGX.experimentalRequestAccessMutation), {
        variables: {
            contentId: contentId,
            accessType: 'edit'
        },
        onCompleted: handleRequestComplete,
        onError: showNotSentFlag
    });
    const handleClick = ()=>{
        if (requestToEditContent && (0, $9wGTI.fg)('editor_request_to_edit_task')) requestToEditContent();
        else requestAccess();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $9YwaJ.default), {
        isDisabled: requestSent,
        onClick: handleClick,
        isLoading: loading,
        iconAfter: requestSent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cvXh8))), {
            spacing: "spacious",
            label: ""
        }) : undefined
    }, intl.formatMessage(requestSent ? (0, $aXWbQ.messages).editRequestSent : (0, $aXWbQ.messages).requestToEdit));
};
const $028f68c4035a3bb9$export$3e2d536de1c1140d = (0, $dIouf.withErrorBoundary)({
    attribution: (0, $dIouf.Attribution).PERMISSIONS_EXPERIENCE
})((0, $7aRa9.withFlags)($028f68c4035a3bb9$export$9b6b5efb5fed0902));

});


//# sourceMappingURL=RequestToEdit.d2755c30.js.map
